import { Stack, Typography } from "@mui/material";
import { WellnessScoreStatus } from "../../../Common/types";
import BreathingRateCard from ".";

export default function BreathingRateCardExamples() {
  return (
    <Stack gap={3} width="100%">
      <Typography variant="h6" fontWeight={600}>
        Healthy
      </Typography>
      <BreathingRateCard
        metricValue="68"
        status={WellnessScoreStatus.Healthy}
        lastUpdated="2025-02-23T00:00:00Z"
      />

      <Typography variant="h6" fontWeight={600}>
        Needs Attention
      </Typography>
      <BreathingRateCard
        metricValue="68"
        status={WellnessScoreStatus.NeedsAttention}
        lastUpdated="2025-02-23T00:00:00Z"
      />

      <Typography variant="h6" fontWeight={600}>
        Needs Support
      </Typography>
      <BreathingRateCard
        metricValue="68"
        status={WellnessScoreStatus.NeedsSupport}
        lastUpdated="2025-02-23T00:00:00Z"
      />
    </Stack>
  );
}
